<div id="app" class="app app-content-full-height app-without-sidebar app-without-header">
  <div id="content" class="app-content p-0">
    <div class="pos pos-vertical pos-with-header">
      <div class="pos-container" [ngClass]="isMobile ? 'p-2' : 'p-4'">

        <app-header></app-header>

        <div class="content__header mb-3">
          <div class="d-flex align-items-center justify-content-between">
            <span class="fs-3 fw-bold">{{title}}</span>
            <div class="d-flex align-items-center">
            </div>
          </div>

          <div class="mt-3">
            <mat-form-field appearance="outline" class="w-100 search-field">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput [(ngModel)]="search" placeholder="Search staff name or ID..." type="text">
              <button mat-icon-button matSuffix *ngIf="search" (click)="search = ''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>

        <!-- Currently Working Section -->
        <div class="section-currently-working mb-4" *ngIf="filteredCurrentlyWorking.length > 0">
          <div class="section-title mb-2 section-toggle" (click)="currentlyWorkingExpanded = !currentlyWorkingExpanded">
            <mat-icon class="toggle-icon">{{currentlyWorkingExpanded ? 'expand_more' : 'chevron_right'}}</mat-icon>
            <i class="fa fa-clock text-warning me-2"></i>
            <span class="fw-semibold">Currently Working ({{currentlyWorking.length}})</span>
          </div>
          <div *ngIf="currentlyWorkingExpanded" class="row g-2">
            <div class="col-6 col-md-4 col-lg-3" *ngFor="let working of filteredCurrentlyWorking">
              <div class="staff-card working-card" (click)="onClockOut(working)">
                <div class="staff-card__avatar">
                  <div class="avatar-circle avatar-working">
                    {{working.staffName?.charAt(0)?.toUpperCase()}}
                  </div>
                </div>
                <div class="staff-card__info">
                  <div class="staff-name">{{working.staffName}}</div>
                  <div class="staff-no text-muted small">{{working.staffNo}}</div>
                  <div class="clock-info mt-1">
                    <span class="badge bg-success">
                      <i class="fa fa-clock me-1"></i>{{formatDuration(working.durationMinutes)}}
                    </span>
                  </div>
                </div>
                <div class="staff-card__action">
                  <span class="clock-out-label">Tap to Clock Out</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- All Staff Section -->
        <div class="section-all-staff">
          <div class="section-title mb-2 section-toggle" (click)="availableStaffExpanded = !availableStaffExpanded">
            <mat-icon class="toggle-icon">{{availableStaffExpanded ? 'expand_more' : 'chevron_right'}}</mat-icon>
            <i class="fa fa-users me-2"></i>
            <span class="fw-semibold">Available Staff ({{filteredAvailableStaff.length}})</span>
          </div>
          <div *ngIf="availableStaffExpanded">
            <div class="row g-2">
              <div class="col-6 col-md-4 col-lg-3" *ngFor="let staff of filteredAvailableStaff">
                <div class="staff-card available-card" (click)="onClockIn(staff)">
                  <div class="staff-card__avatar">
                    <div class="avatar-circle avatar-available">
                      {{staff.name?.charAt(0)?.toUpperCase()}}
                    </div>
                  </div>
                  <div class="staff-card__info">
                    <div class="staff-name">{{staff.name}}</div>
                    <div class="staff-no text-muted small">{{staff.staffNo}}</div>
                  </div>
                  <div class="staff-card__action">
                    <span class="clock-in-label">Tap to Clock In</span>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="filteredAvailableStaff.length === 0 && filteredCurrentlyWorking.length === 0" class="text-center py-5">
              <i class="fa fa-info-circle fa-2x text-muted mb-2"></i>
              <p class="text-muted">No staff found</p>
            </div>
          </div>
        </div>

        <!-- Attendance History Section (Collapsible) -->
        <div class="section-history mt-4">
          <div class="section-title mb-2 section-toggle" (click)="historyExpanded = !historyExpanded">
            <mat-icon class="toggle-icon">{{historyExpanded ? 'expand_more' : 'chevron_right'}}</mat-icon>
            <i class="fa fa-history me-2"></i>
            <span class="fw-semibold">Attendance History ({{attendanceHistory.length}})</span>
          </div>

          <div *ngIf="historyExpanded">
            <div class="d-flex justify-content-end mb-2">
              <select class="form-select p-2 rounded" style="width: 130px" [(ngModel)]="historyFilter" (ngModelChange)="setHistoryFilter($event)">
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
              </select>
            </div>

            <div class="history-table-wrapper" *ngIf="attendanceHistory.length > 0">
              <table class="table table-bordered bg-white">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Staff</th>
                    <th>Date</th>
                    <th>Clock In</th>
                    <th>Clock Out</th>
                    <th>Hours</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let record of attendanceHistory; let i = index">
                    <td>{{i + 1}}</td>
                    <td class="fw-bold">{{record.staffName}}</td>
                    <td>{{record.clockIn | date: 'dd/MM/yy'}}</td>
                    <td>{{formatTime(record.clockIn)}}</td>
                    <td>{{record.clockOut ? formatTime(record.clockOut) : '-'}}</td>
                    <td>{{formatDuration(record.durationMinutes)}}</td>
                    <td>
                      <span class="fw-semibold" [class.text-success]="record.status === 'COMPLETE'" [class.text-danger]="record.status === 'INCOMPLETE'">
                        {{record.status === 'INCOMPLETE' ? 'No Clock Out' : 'Complete'}}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div *ngIf="attendanceHistory.length === 0" class="text-center py-3">
              <div class="d-flex flex-row align-items-center justify-content-center">
                <i class="fa fa-info-circle me-2"></i>
                <span>No attendance records for this period</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
